/* eslint eol-last: 'off', block-spacing: 'off', brace-style: 'off' */
import * as XLSX from "xlsx";
import commonModelHelper from '@/scripts/commonModelHelper';
import common from '@/scripts/common'
import current from '@/scripts/current'
import commonXlsxBuilder from '@/scripts/commonXlsxBuilder';
import store from "@/store";

export default {
    createWorkbook
}
function createWorkbook(reportModel, state, vm) {
    var selectionModel = current.selectionModel;
    var wb = XLSX.utils.book_new();
    var workSheetName = 'Logistic';
    var intro = createIntroduction(reportModel, selectionModel, state);
    XLSX.utils.book_append_sheet(wb, intro, 'Introduction');
    if (reportModel.missingData && reportModel.missingData.hasMissing)
        XLSX.utils.book_append_sheet(wb, commonXlsxBuilder.createMissingDataWorksheet(reportModel), 'Missing Data');
    var ws = createXlsxWorksheet(reportModel, selectionModel, state);
    //workSheetName = workSheetName.replace(/\//g, '-').substring(0, 30);
    XLSX.utils.book_append_sheet(wb, ws, workSheetName);
    return wb;
}

function createXlsxWorksheet(reportModel, selectionModel, state) {
    var rows = [];
    var cellMerges = [];
    var columnWidths = [];
    //cellMerges.push({ s: { c: 0, r: 0 }, e: { c: 6, r: 0 } });
    //cellMerges.push({ s: { c: 0, r: 1 }, e: { c: 6, r: 1 } });
    rows.push(['Behavioral Risk Factor Surveillance System (BRFSS)', null, null, null, null, 'https://www.cdc.gov/brfss']);
    rows.push([]);
    cellMerges.push(wholeRowMerge(rows));
    rows.push(['Logistic Regression' + ', ' + commonModelHelper.getLocationsForXlsx(state.selModel.locations) +
        ' ' + store.state.selModel.years.display]);
    cellMerges.push(wholeRowMerge(rows));
    rows.push([]);
    rows.push(['Dependent Variable:', reportModel.parms.dependentVariable.toString()]);
    rows.push([]);
    reportModel.parms.independentVariables.forEach((v, i) =>
        rows.push([i === 0 ? 'Independent Variables:' : '', v.toString()]));
    rows.push([]);
    rows.push(['', 'Sample Size', 'Beta', 'Standard Error', 't-statistic', 'p-value for t-statistic', 'Odds Ratio', '95% CI for Odds Ratio']);
    rows.push([
        reportModel.parms.dependentVariable.variable.variableTitle + ', Modeling category: ' +
        reportModel.dependentModelCategory]);
    cellMerges.push(wholeRowMerge(rows));
    rows.push(regressionRow('Intercept', reportModel.interceptData));
    rows.push([]);

    reportModel.independentModel.forEach(m => {
        rows.push([m.title]);
        cellMerges.push(wholeRowMerge(rows));
        m.levels.forEach(l => { rows.push(regressionRow2(l)) });
    });

    //console.log(reportModel);
    var statistics = reportModel.modelTestStatistics;
    rows.push([]);
    rows.push(['Model test statistics']);
    rows.push(['Contrast', 'Degrees of Freedom', 'Wald chi-square', 'p-value for Wald chi-square']);
    rows.push(modelTestStatisticRow('Overall Model', statistics.OverallModel));
    rows.push(modelTestStatisticRow('Model minus intercept', statistics.ModelMinusIntercept));
    rows.push(modelTestStatisticRow('Intercept', statistics.Intercept));
    reportModel.parms.independentVariables.forEach(function (variable, variableIndex) {
        rows.push(modelTestStatisticRow(variable.variable.variableTitle, statistics['variable_ind' + (variableIndex + 1)]));
    });

    rows.push([]);
    commonModelHelper.getDatasetTotalRecords(reportModel.recordTotals).forEach(function (theTotal) {
        rows.push([theTotal.label, common.formatNumberNoCommas(theTotal.total, 0)]);
    });


    ////cellMerges.push({ s: { c: 0, r: 0 }, e: { c: 4, r: 1 } });
    //rows.push([]);
    //rows.push([]);

    //if (model.parms.columnVariable !== null && control2.levelsGroupedByRows != null)
    //  addXlsxCrosstab(rows, cellMerges, columnWidths, model, control1, control2, selectionModel, theStatistics);
    //else
    //  addXlsxRowOnly(rows, cellMerges, columnWidths, model, control1, control2, selectionModel, theStatistics);

    //rows.push([]);  //Add blank line

    //if (model.parms.showChiSquare && control2.chiSquare != null)
    //  writeChiSquare(rows, control2);
    //writeTotals(rows, selectionModel, model);


    /* convert an array of arrays in JS to a CSF spreadsheet */
    var ws = XLSX.utils.aoa_to_sheet(rows, { cellDates: true });

    /* TEST: column props */
    ws['!cols'] = columnWidths;

    //Only v and t are set.  t = "s", v is the value of the cell
    //ws['A5'].s = {
    //  wrapText: true,
    //  alignment: { wrapText: true }
    //};

    ws['!merges'] = cellMerges;
    return ws;
}
function regressionRow(categoryTitle, statistics) {
    return [
        categoryTitle + ' ' + (statistics.isSelectedReference ? '(REF)' : ''),
        statistics.sampleSize,
        statistics.betaCoefficient,
        statistics.standardError,
        statistics.tStatistic,
        common.formatNumberWithMinimum(statistics.pValue, 4, statistics.isPValueBelowMinimum),
        statistics.oddsRatio,
        statistics.confidenceInterval
    ];
}
function regressionRow2(level) {
    const s = level.statistics;
    return [
        level.title + ' ' + (level.isReference ? '(REF)' : ''),
        s.sampleSize,
        s.betaCoefficient,
        s.standardError,
        s.tStatistic,
        common.formatNumberWithMinimum(s.pValue, 4, s.isPValueBelowMinimum),
        s.oddsRatio,
        s.confidenceInterval
    ];
}
function modelTestStatisticRow(variableTitle, statistics) {
    return [
        variableTitle,
        statistics.degreesOfFreedom,
        statistics.waldChiSquare,
        common.formatNumberWithMinimum(statistics.pValue, 4, statistics.isPValueBelowMinimum)
    ];
}
function wholeRowMerge(rows) {
    var rowNumber = rows.length - 1;
    return { s: { c: 0, r: rowNumber }, e: { c: 7, r: rowNumber } }
}
/*Call this before adding the row to get the correct row number*/
// function mergeCellAcrossRows(rows, column, numberOfRows) {
//   var thisRow = rows.length;
//   return { s: { c: column, r: thisRow }, e: { c: column, r: thisRow + numberOfRows - 1 } };
// }
// function mergeCellAcrossColumns(rows, firstColumn, lastColumn) {
//   var thisRow = rows.length - 1;
//   return { s: { c: firstColumn, r: thisRow }, e: { c: lastColumn, r: thisRow } };
// }

function createIntroduction(p, model, selectionModel, state) {
    var rows = introduction.slice();
    //if (selectionModel.v.control1.include)
    //  addTabDescriptions(p, model, selectionModel, state, rows);
    rows = rows.concat(introductionDefinitions);
    var ws = XLSX.utils.aoa_to_sheet(rows, { cellDates: true });
    return ws;
}

var introduction = [
    ['BRFSS Web Enabled Analysis Tool: Logistic Regression'],
    [],
    ['Introduction:'],
    ['', 'Logistic regression allows you to generate models that predict a binary dependent variable from one or more independent, or predictor, variables.']
];

var introductionDefinitions = [
    [],
    ['Definitions:'],
    ['', 'Logisic Regression:', ''],
    ['', 'Dependent Variable:', ''],
    ['', 'Independent Variable:', ''],
    ['', 'Sample Size:', ''],
    ['', 'Beta:', ''],
    ['', 'Intercept:', ''],
    ['', 'Standard Error: (Abbreviations)', ''],
    ['', 't - statistic:', ''],
    ['', 'p - value:', ''],
    ['', 'Odds Ratio:', ''],
    ['', 'Confidence Interval: (Abbreviations)', ''],
    ['', 'Degrees of Freedom:', ''],
    ['', 'Contrast:', ''],
    ['', 'Wald chi- square:', ''],
    ['', 'Weighted Sample Size:', ''],
    ['', 'Reference Category:', '']
];
